import React, { useEffect, useState } from 'react';
import { ReactComponent as LeftArrow } from 'icons/left-arrow.svg';
import SchedulePriceDetail from './SchedulePriceDetail';
import { useNavigate, useSearchParams } from 'react-router-dom';

const DetailSchedulePage = () => {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const [params, setParams] = useState();

  useEffect(() => {
    const params = searchParams.get('tab');
    setParams(params);
  }, [searchParams]);

  return (
    <div className="detail-schedule-page">
      {/* ARROW BACK */}
      <button
        className="detail-schedule-page__header"
        onClick={() => navigate(-1)}
        style={{ border: 'none', background: 'transparent' }}
      >
        <LeftArrow />
        <span>Kembali</span>
      </button>

      {/* CONTENT */}
      {params === 'Schedule Price' ? <SchedulePriceDetail /> : null}
    </div>
  );
};

export default DetailSchedulePage;
